module.exports = __webpack_public_path__ + "static/media/walkthrough-product.8b610802.jpg";